module.exports = __webpack_public_path__ + "static/media/img_process5.c3fd4fc8.png";